import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import'./assets/css/base.css'
import utils from './assets/common/index'

import * as echarts from 'echarts';

//全局封装axios
import request from '@/utils/request'
import userSercive from "@/assets/common/http/user";
Vue.config.productionTip = false

Vue.use(ElementUI);
// //使用一个参数使用this.$request
// Vue.prototype.$request=request
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  utils,
  render: h => h(App)
}).$mount('#app')
